import { Card, CardContent } from "@/components/ui/card";

function Field({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className="text-sm font-medium">{value || "—"}</div>
    </div>
  );
}

/** Read-only summary grid of the surgical case. */
export default function ResumoTab({ cs }) {
  return (
    <Card><CardContent className="p-6 grid grid-cols-1 md:grid-cols-3 gap-5">
      <Field label="Cirurgião" value={cs.surgeon?.full_name} />
      <Field label="Auxiliar" value={cs.assistant_surgeon?.full_name} />
      {cs.assistant_surgeon_2?.full_name ? (
        <Field label="3º Cirurgião" value={cs.assistant_surgeon_2.full_name} />
      ) : null}
      <Field label="Anestesista" value={cs.anesthesiologist?.full_name} />
      <Field label="Instrumentador" value={cs.instrument_technician?.full_name} />
      <Field label="Hospital" value={cs.hospital?.name} />
      <Field label="Leito" value={cs.bed} />
      <Field label="Diagnóstico" value={cs.diagnosis} />
      <Field label="Docs assinados" value={String((cs.signed_documents || []).length)} />
    </CardContent></Card>
  );
}
